import Drawer from "@mui/material/Drawer";
import useMediaQuery from "@mui/material/useMediaQuery";
import type React from "react";

interface SidenavDrawerProps {
  open: boolean;
  children: React.ReactNode;
}

export default function SidenavDrawer({ open, children }: SidenavDrawerProps) {
  const isNotDesktop = useMediaQuery("(max-width:1199px)");

  return (
    <>
      {isNotDesktop ? (
        <Drawer
          variant="temporary"
          open={open}
          ModalProps={{
            keepMounted: true,
          }}
          sx={{
            display: { xs: "block", lg: "none" },
            "& .MuiDrawer-paper": { boxSizing: "border-box", width: "100%", bgcolor: "#FAFAFA" },
          }}
        >
          {children}
        </Drawer>
      ) : (
        <Drawer
          variant="permanent"
          anchor="left"
          sx={{
            display: { xs: "none", lg: "block" },
            flexShrink: 0,
            width: 366,
            "& .MuiDrawer-paper": {
              width: 366,
              boxSizing: "border-box",
              bgcolor: "#FAFAFA",
            },
          }}
        >
          {children}
        </Drawer>
      )}
    </>
  );
}
